import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { ICompanyCountryExtended } from '../../../../../type_definitions/datatypes';

export interface IProfileSLAResponse {
  distributorsSlas:IProfileSLA[];
  profileSla:IProfileSLA;
}

export interface IProfileSLA {
  companyCountry:ICompanyCountryExtended;
  slaDefinitions:IProfileSLADefinition[];
}

export interface IProfileSLADefinition {
  companyType?:string;
  defaultDays?:number;
  description?:string;
  id?:string;
  sequence?:number;
  textFrom?:string;
  textTo?:string;
  slaValue?:IProfileSLAValue;
  showInfo?:boolean;
}

export interface IProfileSLAValue {
  id?:number;
  days?:number;
  comments?:string;
}

@Injectable()
export class BPProfilesSLADataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getSLA(profileId:number, countryId:number):Promise<IProfileSLAResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${profileId}/groupedslavalues/${countryId}`,
      undefined,
      undefined,
      'Error loading SLA'
    );
  }

  public saveSLA(profileId:number, countryId:number, data:IProfileSLA[]):Promise<IProfileSLAResponse> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${profileId}/groupedslavalues/${countryId}`,
      undefined,
      data,
      undefined,
      'Error saving SLA'
    );
  }
}